<script>
import companyApi from '@/api/company';
import popupModel from '@/model/popup';
import model from '@/model/company';
import { markVisited } from '@/utils/newPage';

import CompanyFormPopupWrappable from '@/components/company/CompanyFormPopupWrappable.vue';
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import CompanyTile from '@/components/company/CompanyTile.vue';
import EmptyList from '@/components/ui/EmptyList.vue';


export default {
  name: 'CompanyListPage',
  components: { EmptyList, CommonSection, DefaultLayout, CompanyTile },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    currUser() { return this.$store.state.auth.user ?? {}; },
  },
  async created() {
    await this.fetch();
    markVisited('companyListPage');
  },
  methods: {
    async fetch() {
      const res = await companyApi.fetchList({}, true);
      this.items = res.items;
    },
    getMenuItems(item) {
      const isOwner = item?.owner?.id === this.currUser?.id;
      // const isDeputy = item.deputies.find(e => e.user.id === this.currUser.id);

      // if (!isOwner && !isDeputy) return [];
      if (!isOwner) return [];

      const items = [];

      items.push({
        text: 'Редактировать',
        icon: 'edit',
        handler: () => { this.editItem(item); },
      });
      items.push({
        text: 'Удалить',
        icon: 'trash',
        handler: () => { this.deleteItem(item); },
      });

      return items;
    },
    async addItem() {
      await model.addCompany();
      await this.fetch();
    },
    async editItem({ id, name }) {
      const data = await popupModel.add({
        wrappable: true,
        component: CompanyFormPopupWrappable,
        params: { id, name },
      });

      await companyApi.update(id, data, true);
      await this.fetch();
    },
    async deleteItem({ id, name }) {
      const answer = await this.$confirm(`Вы действительно хотите удалить компанию [${name}]?`)
      if (!answer) return;
      companyApi.delete(id, true)
        .then(() => { this.fetch() })
        .catch(e => {
          const err = e.description === 'Unable to delete company with departments'
            ? 'Невозможно удалить компанию с отделами. Удалите все отделы, кноме отдела управления, после чего повторите попытку.'
            : 'Неизвестная ошибка';
          this.$alert(err);
        });
    },

  },
};
</script>


<template lang="pug">
  DefaultLayout
    CommonSection(title="Компании")
      template(#button)
        .header-buttons
          Btn(dark xl @click="addItem")
            Icon(name="plus")
            | Создать компанию
      .b-company-list-page(v-if="items.length")
        CompanyTile(v-for="item in items" :key="item.id" :item="item" :menu="getMenuItems(item)")
      EmptyList(v-else) У Вас пока нет компаний
</template>


<style lang="scss">
.company-list-page {
  display: grid;
  grid-template-columns: 1fr;
  gap: 37px;
}
</style>
